// Libraries
import { MenuItemType } from 'antd/lib/menu/hooks/useItems';

// Types
import { EquipmentUnitDataConeCrusher } from '../../../../../../types/crusher';
import {
  EdgeDeviceOperationalStatus,
  LengthType,
  PressureType,
  TemperatureType,
} from '../../../../../../types/global';

export enum SetpointType {
  automation = 'automation',
  crusher = 'crusher',
  hydraulic = 'hydraulic',
  lubrication = 'lubrication',
  vibration = 'vibration',
}

export type SetpointItemTab = {
  key: SetpointType;
  label: string;
};

export interface SetpointContext {
  unitData: EquipmentUnitDataConeCrusher | null;
  edgeStatus: EdgeDeviceOperationalStatus | null;
  temperatureUnit: TemperatureType;
  pressureUnit: PressureType;
  lengthUnit: LengthType;
  isDakota: boolean;
}

export interface SetpointProps {
  className?: string;
  onChangeView: (key: MenuItemType) => void;
  unitData: EquipmentUnitDataConeCrusher | null;
  edgeStatus: EdgeDeviceOperationalStatus | null;
  selectedView: SetpointType;
  testId?: string;
}
